import React from 'react';
import styled from 'styled-components';

const GameContainer = styled.div`
  width: 100%;
  height: calc(100vh - 200px); // Adjusted for the header and sub-navigation
  overflow: hidden;
`;

const GameFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

const ColorMerge = () => {
  return (
    <GameContainer>
      <GameFrame 
        src="/colorMerge/index.html"
        title="Color Merge Game"
      />
    </GameContainer>
  );
};

export default ColorMerge; 